export enum SubscriptionsRoutes {
  root = 'subscription',
  main = '',
  pending = 'pending',
  tenant = 'tenant',
  sidedrawers = 'sidedrawers',
  users = 'users',
}
